import { Box, ButtonBase, useTheme } from "@mui/material";
import { useEffect, useState } from "react";

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { useTranslation } from "react-i18next";
import { tokens } from "../../../theme";
import { showToastMessagePostRequest, showToastMessageRequestError, showToastMessageUpdateRequest } from "../../../utils/toasts";
import SHModal from "../../theme/Modal/SHModal";
import Shbutton from "../../theme/buttons/Shbutton";
import Subheading from "../../theme/text/Subheading";
import Text from "../../theme/text/Text";
// import { required } from '../../utils/validation';
import { useGetOrderLinesQuery, useSplitOrderMutation, useUpdateOrderMutation } from "../../../newapi/order/ordersSlice";
import SplitOrderLine from "../../splitorder/SplitOrderLine";
import ButtonGroup from "../../theme/buttons/ButtonGroup";
import { useGetOrderFieldsSelectQuery } from "../../../newapi/order/orderFieldSlice";
import { booleanValueTypes, dropdownValueTypes, numberValueTypes, textValueTypes } from "../../Streams/Conditions/ConditionSettings";
import TextInput from "../../theme/inputs/TextInput";
import ShSwitch from "../../theme/inputs/ShSwitch";

import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { InputDropdown } from "../../theme/dropdowns/InputDropdown";
import EMGeneralExplainerBox from "../ModalsPopover/explainers/EMGeneralExplainerBox";
import { useSelector } from "react-redux";
import { ENV_TYPES } from "../Sidebar";
import ShValidatedInput from "../../theme/inputs/ShValidatedInput";
import { selectUserPermission } from "../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from "../../../utils/permissions";
import NumberInput from "../../theme/inputs/NumberInput";
import { buildPickupMethodRemark, parsePickupMethodRemark } from "../../../utils/helpers";

const MEditOrderExtraFields = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const colors = tokens(theme.palette.mode);

    const {data: orderFields, isLoading: orderFieldsLoading} = useGetOrderFieldsSelectQuery();
    const [orderToEditData, setOrderToTeEditData] = useState(null);

    const hasWebshopReferencePermission = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.OUTBOUND_MODIFY_WEBSHOPREFERENCE])
    );

    useEffect(() => {
        // Reload on every open so unsaved edits from a cancelled session are dropped
        if(props.open && props.data){
            setOrderToTeEditData(props.data);
        }
    },[props.data, props.open])


    const handleInput= (key,val) => {
        setOrderToTeEditData((prev) => ({
            ...prev,
            [key]:val,
        }))
    }

    // The pickup method is stored at the end of the remark
    const pickupRemark = parsePickupMethodRemark(orderToEditData?.remark);
    const pickupMethodOptions = [
        { id: "boxes", name: t("loose_boxes") },
        { id: "pallet", name: t("pallet") },
    ];
    const handlePickupMethodInput = (key, val) => {
        const next = { ...pickupRemark, [key]: val };
        handleInput("remark", buildPickupMethodRemark(next.remark, next.pickupMethod, next.maxHeight));
    };

    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    const [updateOrder,{isLoading: isUpdateLoading}] = useUpdateOrderMutation();
    const handleOrderUpdate = async() => {
        try {
            if (isUpdateLoading) return;

            const data = await updateOrder({
                id:orderToEditData.id,
                remark: orderToEditData.remark,
                isB2B: orderToEditData.isB2B,
                ...(hasWebshopReferencePermission ? {webshopreference: orderToEditData.webshopreference} : {}),
                orderFieldValues: orderToEditData.orderFieldValues
            }).unwrap()
            showToastMessageUpdateRequest(t, data);
            props.handleClose(false);
        } catch (err) {
            showToastMessageRequestError(t("update_failed"), t, err);
        }
    }

    const selectedEnvironmentType = useSelector((state) => state.settings.environment.selectedEnvironmentType);
    const isRelation = selectedEnvironmentType === ENV_TYPES[200];

    return(
        <SHModal
            open={props.open}
            onClose={() => props.handleClose(false)}
        >
                <Box 
                    sx={{
                        textAlign:"center",
                        paddingY:4,
                        paddingX:5,
                        display:"flex",
                        flexDirection:"column",
                        gap:1
                    }}
                >
                    <Subheading>{t("edit_order")}</Subheading>
                    <Text center light>{t("edit_order_subtitle")}</Text>
                </Box>
                
                {/* BODY */}
                <Box
                    sx={{
                        background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                        padding:3,
                        pb:1,
                        borderTopLeftRadius:16,
                        borderTopRightRadius:16,
                        display:"flex",
                        width:1,
                        gap:2,
                        flexDirection:"column"
                        // overflow:"scroll"
                    }}
                >
                    {!isRelation && hasWebshopReferencePermission &&

                        <Box 
                            sx={{
                                width:1,
                                display:"flex",
                                alignItems:"center",
                                justifyContent:"space-between",
                                gap:7
                            }}
                        >
                            <Box
                                sx={{
                                    width:140,
                                    flexShrink:0,
                                }}
                            >
                                <Text>{t("webshopreference")}</Text>
                            </Box>
                            
                            <Box
                                sx={{
                                    flex:1,
                                    borderRadius:4,
                                    display:"flex",
                                }}
                            >
                                <ShValidatedInput
                                    height={40}
                                    name="webshopreference"
                                    value={orderToEditData?.webshopreference}
                                    onChange={handleInput}
                                    // error={""}
                                />
                            </Box>
                        </Box>
                    }

                    <Box 
                        sx={{
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:7
                        }}
                    >
                        <Box
                            sx={{
                                width:140,
                                display:"flex",
                                alignItems:"center",
                            }}
                        >
                            <Text>{t("b2b_order")}</Text>
                            <EMGeneralExplainerBox title={t('em_b2b_title')} text={t('em_b2b_text')}/>
                        </Box>
                        
                        <Box
                            sx={{
                                flex:1,
                                borderRadius:4,
                                display:"flex",
                                height:32
                            }}
                        >
                        <ShSwitch
                            checked={orderToEditData?.isB2B ?? false}
                            onChange={(e) => handleInput('isB2B', e.target.checked)}
                        />
                        </Box>
                    </Box>
                    <Box 
                        sx={{
                            width:1,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            gap:7
                        }}
                    >
                        <Box
                            sx={{
                                width:140,
                                flexShrink:0,
                            }}
                        >
                            <Text>{t("remark")}</Text>
                        </Box>
                        
                        <Box
                            sx={{
                                flex:1,
                                borderRadius:4,
                                display:"flex",
                            }}
                        >
                            <ShValidatedInput
                                height={40}
                                name="remark"
                                value={pickupRemark.remark}
                                onChange={handlePickupMethodInput}
                                // error={""}
                            />
                        </Box>
                    </Box>
                    {orderToEditData?.deliveryMethod === "pickup" && (
                        <Box 
                            sx={{
                                width:1,
                                display:"flex",
                                alignItems:"center",
                                justifyContent:"space-between",
                                gap:7
                            }}
                        >
                            <Box
                                sx={{
                                    width:140,
                                    flexShrink:0,
                                }}
                            >
                                <Text>{t("pickup_method")}</Text>
                            </Box>
                            
                            <Box
                                sx={{
                                    flex:1,
                                    background: colors.grey[100],
                                    borderRadius:4,
                                    display:"flex",
                                }}
                            >
                                <InputDropdown
                                    displayName={"name"}
                                    valueKey={"id"}
                                    closeOnSelection
                                    disallowDeselection
                                    selected={pickupRemark.pickupMethod ?? -1}
                                    options={pickupMethodOptions}
                                    noSelection={t("choose_option")}
                                    onChange={(selected) => handlePickupMethodInput("pickupMethod", selected)}
                                />
                            </Box>
                        </Box>
                    )}
                    {orderToEditData?.deliveryMethod === "pickup" && pickupRemark.pickupMethod === "pallet" && (
                        <Box 
                            sx={{
                                width:1,
                                display:"flex",
                                alignItems:"center",
                                justifyContent:"space-between",
                                gap:7
                            }}
                        >
                            <Box
                                sx={{
                                    width:140,
                                    flexShrink:0,
                                }}
                            >
                                <Text>{t("max_height")} (cm)</Text>
                            </Box>
                            
                            <Box
                                sx={{
                                    flex:1,
                                    display:"flex",
                                }}
                            >
                                <NumberInput
                                    btnSize={"24"}
                                    height={32}
                                    maxWidth={160}
                                    onlyPositive
                                    min={0}
                                    value={pickupRemark.maxHeight ?? ''}
                                    change={(val) => handlePickupMethodInput("maxHeight", val)}
                                />
                            </Box>
                        </Box>
                    )}

                    {orderFields && orderFields.length > 0 && (
                        <Box
                            sx={{
                                mx: "-12px",
                                px: 1.5,
                                pt: 1,
                                pb: 1.5,
                                mt: 1,
                                borderRadius:3,
                                background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[50],
                                display: "flex",
                                gap: 1,
                                flexDirection: "column",
                            }}
                        >
                            <Subheading>{t("custom_fields")}</Subheading>

                            {orderToEditData?.orderFieldValues?.map((field, idx) => (
                                <Box
                                    key={"field" + idx}
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <Box
                                        sx={{
                                            width: 140,
                                            mr: 7,
                                        }}
                                    >
                                        <Text>{field.orderfield.name}</Text>
                                    </Box>

                                    <Box sx={{ flex: 1 }}>
                                        {(textValueTypes.includes(field.orderfield.valueType) ||
                                            numberValueTypes.includes(field.orderfield.valueType)) && (
                                            <Box
                                                sx={{
                                                    background: colors.grey[100],
                                                    height: 32,
                                                    borderRadius: 4,
                                                    width: 1,
                                                    "&:hover": {
                                                        background: colors.grey[200],
                                                        cursor: "pointer",
                                                    },
                                                }}
                                            >
                                                <TextInput
                                                    type={textValueTypes.includes(field.valueType) ? "text" : "number"}
                                                    value={field.value || ""}
                                                    background="transparent"
                                                    onChange={(e) => {
                                                        const newValue = e.target.value;
                                                        setOrderToTeEditData(prev => ({
                                                            ...prev,
                                                            orderFieldValues: prev.orderFieldValues.map(f =>
                                                                f.orderfieldId === field.orderfieldId
                                                                    ? { ...f, value: newValue }
                                                                    : f
                                                            )
                                                        }));
                                                    }}
                                                />
                                            </Box>
                                        )}

                                        {booleanValueTypes.includes(field.orderfield.valueType) && (
                                            <Box>
                                                <ShSwitch
                                                    checked={field.value === true || field.value === "true"}
                                                    onChange={(e) => {
                                                        const checked = e.target.checked;
                                                        setOrderToTeEditData(prev => ({
                                                            ...prev,
                                                            orderFieldValues: prev.orderFieldValues.map(f =>
                                                                f.orderfieldId === field.orderfieldId
                                                                    ? { ...f, value: checked }
                                                                    : f
                                                            )
                                                        }));
                                                    }}
                                                />
                                            </Box>
                                        )}

                                        {dropdownValueTypes.includes(field.orderfield.valueType) && (() => {
                                            // Find the full field definition from orderFields to get listValues
                                            const fullField = orderFields?.find(of => of.id === field.orderfieldId);
                                            const listValues = fullField?.listValues ?? field.orderfield.listValues ?? [];

                                            return (
                                                <Box
                                                    sx={{
                                                        background: colors.grey[100],
                                                        borderRadius: 4,
                                                        width: 1,
                                                    }}
                                                >
                                                    <InputDropdown
                                                        searchOptions={{
                                                            enabled: true,
                                                            placeholder: t("search")
                                                        }}
                                                        closeOnSelection
                                                        selected={listValues?.findIndex(item => item === field.value) ?? -1}
                                                        options={listValues}
                                                        onChange={(selectedIndex) => {
                                                            const selectedValue = listValues[selectedIndex];
                                                            setOrderToTeEditData(prev => ({
                                                                ...prev,
                                                                orderFieldValues: prev.orderFieldValues.map(f =>
                                                                    f.orderfieldId === field.orderfieldId
                                                                        ? { ...f, value: selectedValue }
                                                                        : f
                                                                )
                                                            }));
                                                        }}
                                                    />
                                                </Box>
                                            );
                                        })()}
                                    </Box>

                                    <ButtonBase
                                        onClick={() => {
                                            setOrderToTeEditData(prev => ({
                                                ...prev,
                                                orderFieldValues: prev.orderFieldValues.filter(
                                                    f => f.orderfieldId !== field.orderfieldId
                                                )
                                            }));
                                        }}
                                        sx={{
                                            width: 32,
                                            height: 32,
                                            color: colors.red[400],
                                            ml: 1,
                                            borderRadius: 4,
                                        }}
                                    >
                                        <DeleteOutlineOutlinedIcon />
                                    </ButtonBase>
                                </Box>
                            ))}

                            <InputDropdown
                                searchOptions={{
                                    enabled:true,
                                    placeholder:t("search")
                                }}
                                resetOnSelection
                                closeOnSelection
                                selected={-1}
                                options={orderFields}
                                onChange={(selectedIndex) => {
                                    const selectedField = orderFields[selectedIndex];
                                    setOrderToTeEditData(prev => {
                                        const exists = prev.orderFieldValues.some(f => f.orderfield.id === selectedField.id);
                                        if (exists) return prev;

                                        return {
                                            ...prev,
                                            orderFieldValues: [
                                                ...prev.orderFieldValues,
                                                {
                                                    orderfieldId: selectedField.id,
                                                    orderfield: {
                                                        name: selectedField.name,
                                                        valueType: selectedField.valueType,
                                                        listValues: selectedField.listValues ?? [],
                                                    },
                                                    ...(selectedField.valueType === 'boolean' ? { value: false } : {}),
                                                }
                                            ]
                                        };
                                    });
                                }}
                                
                            />
                        </Box>
                    )}

                </Box>

                <Box
                    component="footer"
                    sx={{
                        display:"block",
                        width:1,
                        paddingBottom: isStandAlone ? "32px" : "16px",
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        paddingRight:3,
                        zIndex:1058,
                        position:"relative",
                        paddingTop:2,
                        background:`${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                        borderBottomLeftRadius:24,
                        borderBottomRightRadius:24,
                        "@media screen and (max-width: 47.9375em)" : {
                            paddingRight:0,
                        }
                    }}
                >
                    <Shbutton isCancel={true} className={"always-visible"} onClick={() => props.handleClose(false)} color="primary" variant="text" startIcon={<ArrowRightAltIcon/>}>{t("cancel")}</Shbutton>
                    <ButtonGroup version={2}>
                        <Shbutton className={"group-btn"} color={theme.palette.mode === "dark" ? "blue" : "primary"}
                            block
                            variant="contained" 
                             isLoading={isUpdateLoading}
                             onClick={() => handleOrderUpdate()}
                        >
                            {t("save")}
                        </Shbutton>
                    </ButtonGroup>
                </Box>
        </SHModal>
        
    )
}

export default MEditOrderExtraFields;
